<template>
    <div class="yy">
      <!-- 上盒子 -->
      <div class="yy-box1">
          <!-- <div class="yy-box1-1">走进翼博</div> -->
          <ul>
              <li><router-link to="/honor/myzs1">企业简介</router-link></li>
              <li><router-link to="/honor/myzs2">企业文化</router-link></li>
              <li><router-link to="/honor/myzs3">组织架构</router-link></li>
              <li><router-link to="/honor/myzs4">企业资质</router-link></li>
              <li><router-link to="/honor/myzs7">企业体系认证</router-link></li>
              <li><router-link to="/honor/myzs8">企业信用认证</router-link></li>
              <li><router-link to="/honor/myzs5">荣誉证书</router-link></li>
              <li><router-link to="/honor/myzs6">新闻动态</router-link></li>
          </ul>
      </div>
  
      <!-- 下盒子 -->
      <div class="ryzs">
        <img class="sizeSty" src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-48-17-361%E8%AF%9A%E4%BF%A1%E4%BE%9B%E5%BA%94%E5%95%86%E7%AD%89%E7%BA%A7%E8%AF%81%E4%B9%A6.jpg" alt="">
        <img class="sizeSty" src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-48-17-361%E8%AF%9A%E4%BF%A1%E4%BE%9B%E5%BA%94%E5%95%86%E7%AD%89%E7%BA%A7%E8%AF%81%E4%B9%A6.jpg" alt="">
        <img class="sizeSty" src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-48-43-119%E8%AF%9A%E4%BF%A1%E4%BC%81%E4%B8%9A%E5%AE%B6.jpg" alt="">
        <img class="sizeSty" src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-48-43-119%E8%AF%9A%E4%BF%A1%E4%BC%81%E4%B8%9A%E5%AE%B6.jpg" alt="">
        <img class="sizeSty" src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-50-02-919%E7%AB%8B%E4%BF%A1%E5%8D%95%E4%BD%8D%E8%AF%81%E4%B9%A6.jpg" alt="">
        <img class="sizeSty" src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-49-52-360%E4%BC%81%E4%B8%9A%E4%BF%A1%E7%94%A8%E7%AD%89%E7%BA%A7%E8%AF%81%E4%B9%A6.jpg" alt="">
        <img class="sizeSty" src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-50-13-414%E8%A1%8C%E4%B8%9A%E8%AF%9A%E4%BF%A1%E5%8D%95%E4%BD%8D%E8%AF%81%E4%B9%A6.jpg" alt="">
        <img class="sizeSty" src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-51-14-412%E8%B4%A8%E9%87%8F%E6%9C%8D%E5%8A%A1%E8%AF%9A%E4%BF%A1%E5%8D%95%E4%BD%8D%E8%AF%81%E4%B9%A6.jpg" alt="">
        <img class="sizeSty" src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-51-45-903%E9%87%8D%E5%90%88%E5%90%8C%E5%AE%88%E4%BF%A1%E7%94%A8%E4%BC%81%E4%B8%9A.jpg" alt="">
        <img class="sizeSty" src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-51-36-505%E8%B5%84%E4%BF%A1%E7%AD%89%E7%BA%A7%E8%AF%81%E4%B9%A6.jpg" alt="">
        <img style="width: 80%" src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-47-54-2233A%E7%89%8C%E5%8C%BE-%E7%94%B5%E5%AD%90%E7%89%88.jpg" alt="">
        
          
      </div>
    </div>
  </template>

<script>
export default {

}
</script>

<style scoped>
*{
    box-sizing: border-box;
}
.ryzs {
  width: 80%;
  margin: 0 auto;
}
.sizeSty {
  width: 40%;
}
</style>